import { useParams } from 'react-router';
import { Page } from '@betty/navigation';
import Gameplay from '../components/Gameplay/Gameplay';
import { useCallback } from 'react';
import { Box, useBreakpointProp } from '@betty/moonlight';
import { DeviceType } from '../index.types';

function GameLaunchPage() {
  const { id, currencyCode } = useParams();
  const deviceType = useBreakpointProp<DeviceType>({
    mobile: 'mobile',
    tablet: 'mobile',
    desktop: 'desktop',
  });

  const onGameExit = useCallback(() => {
    // navigation.popToTop();
  }, []);

  const onGameDeposit = useCallback(() => {
    // navigation.popToTop();
    // navigation.navigate('Deposit');
  }, []);

  return (
    <Page>
      <Box flex={1}>
        <Gameplay
          id={Number(id)}
          deviceType={deviceType}
          currencyCode={currencyCode}
          onExit={onGameExit}
          onDeposit={onGameDeposit}
        />
      </Box>
    </Page>
  );
}

export default GameLaunchPage;
